import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ThemisRoute } from 'src/app/navbar/edumono-route';

@Component({
  selector: 'edu-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderTitleComponent implements OnInit {
  @Input() route: ThemisRoute;
  @Input() darkMode: boolean;
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.iconRegistry.addSvgIcon(
      this.route.name,
      this.sanitizer.bypassSecurityTrustResourceUrl(this.route.image),
    );
  }
}
